const OFFLINE_USER_ALLOWED_FIELDS = [
  'id',
  'username',
  'name',
  'roles',
  'role',
  'color',
  'phone_number',
  'disabled_at',
  'tenant_id',
];

export function offlineUserRoles(user) {
  if (!user || typeof user !== 'object') return [];
  if (Array.isArray(user.roles)) {
    return [...new Set(user.roles.filter((role) => typeof role === 'string' && role))].sort();
  }
  if (typeof user.role === 'string' && user.role) return [user.role];
  return [];
}

export function buildOfflineUserReadModel(users) {
  if (!Array.isArray(users)) return [];
  return users
    .filter((user) => user && typeof user === 'object' && typeof user.id === 'string' && user.id)
    .map((user) => {
      const cached = {};
      OFFLINE_USER_ALLOWED_FIELDS.forEach((field) => {
        if (
          Object.prototype.hasOwnProperty.call(user, field)
          && user[field] !== null
          && user[field] !== undefined
        ) {
          cached[field] = user[field];
        }
      });
      cached.roles = offlineUserRoles(cached);
      delete cached.role;
      return cached;
    });
}

export function buildOfflineUserLookup(users) {
  return buildOfflineUserReadModel(users).reduce((lookup, user) => {
    lookup[user.id] = user;
    return lookup;
  }, {});
}

export function offlineUserDisplayName(user, fallback = 'Unknown user') {
  if (!user || typeof user !== 'object') return fallback;
  return user.name || user.username || fallback;
}
